import React from "react";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;

  const cards = [
    { icon: Phone, label: c.call, value: "+32 465 64 11 69", href: "tel:+32465641169", testid: "contact-phone" },
    { icon: EnvelopeSimple, label: c.write, value: "info@ebenezertaxi.be", href: "mailto:info@ebenezertaxi.be", testid: "contact-email" },
    { icon: MapPin, label: c.area, value: c.areaVal, href: null, testid: "contact-area" },
    { icon: Clock, label: "24/7", value: "24h/24 · 7j/7", href: null, testid: "contact-hours" },
  ];

  return (
    <section id="contact" className="cfg relative py-16 md:py-24 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <Reveal>
              <p className="cfg-body text-[12px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-3">{c.overline}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="cfg-display text-3xl md:text-5xl text-[#071B2F] tracking-tight">{c.title}</h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="cfg-body text-[#071B2F]/55 mt-4 max-w-md">{c.sub}</p>
            </Reveal>
            <Reveal delay={0.3}>
              <a href="tel:+32465641169" data-testid="contact-call-cta" className="cfg-body inline-flex items-center gap-3 mt-7 rounded-2xl bg-[#071B2F] text-white px-7 py-4 text-sm font-medium tracking-wide hover:bg-[#0a2440] transition-colors">
                <Phone weight="fill" size={18} className="text-[#D4AF37]" /> +32 465 64 11 69
              </a>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {cards.map((card, i) => {
              const Inner = (
                <div className="group h-full rounded-[24px] border border-[#071B2F]/10 bg-white p-7 hover:border-[#D4AF37]/50 shadow-[0_20px_50px_-35px_rgba(7,27,47,0.35)] transition-colors">
                  <card.icon weight="light" size={28} className="text-[#D4AF37] group-hover:scale-110 transition-transform" />
                  <p className="cfg-body text-[10px] tracking-[0.2em] uppercase text-[#071B2F]/40 mt-5">{card.label}</p>
                  <p className="cfg-body text-[#071B2F] text-lg mt-1">{card.value}</p>
                </div>
              );
              return (
                <Reveal key={i} delay={i * 0.08}>
                  {card.href ? <a href={card.href} data-testid={card.testid} className="block h-full">{Inner}</a> : <div data-testid={card.testid} className="h-full">{Inner}</div>}
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
